<template>
    <div>
      <Header />
      <!-- Bannières de notification centralisées -->
      <div class="notifications-container">
        <q-banner v-if="success" class="app-banner app-banner--success" dense rounded>
          Données enregistrées
        </q-banner>
        <q-banner v-if="saveError" class="app-banner app-banner--error" dense rounded>
          Erreur durant l'enregistrement des données
        </q-banner>
      </div>

      <div>
        <div class="title">
          <div class="navTitle">
            <span class="exhibitTitle" style="font-style: default;">{{ exhibitName }} : </span>
            <span @click="navigateToExhibits" style="font-style: italic;"> Retourner aux expositions > </span>
            <span @click="navigateToExpo_bu" style="font-style: italic;"> Créer la page d'accueil > </span>
            <!--<span @click="navigateToCreation" style="font-style: italic;"> Choisir le type de création</span>-->
            <span style="font-style: italic;"> > Choisir la galerie</span>
          </div>
        </div>

        <div class="navButtons">
          <q-btn color="pink-10" style="margin-left: 7%" @click="navigateBack">Retour</q-btn>
          <div>
            <q-btn label="Prévisualiser l'exposition en ligne" color="blue-grey-4" @click="openNewTab" />
          </div>
          <div style="margin-right: 7%">
            <q-btn label="Valider l'exposition" color="blue-grey-4" @click="exhibitValidation" />
          </div>
        </div>
      </div>
      <hr style="margin-bottom: 15px" />

      <div class="container">
        <!-- Colonne de gauche : Import et gestion des fichiers -->
        <div class="column">
          <h4><q-icon name="cloud_upload" /> Importer des fichiers pour la création de la galerie</h4>
          <q-form>
            <label for="file">(Images, Vidéos, documents word, ou Audios uniquement)</label>
            <input
              outlined
              style="margin-bottom:3%"
              type="file"
              label="Fichier"
              id="file"
              @change="selectFile"
              :key="inputKey"
              accept="image/*,video/*,audio/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            />
            <q-input outlined v-model="title" label="Titre"></q-input>
            <br>
            <q-input outlined type="textarea" label="Description" v-model="description"></q-input>
            <br>
            <q-input outlined v-model="source" label="Nom de la source"></q-input>
            <br>
            <q-input outlined v-model="source_url" label="URL de la source"></q-input>
            <br>
            <q-btn @click="importImage" color="secondary" label="Enregistrer" />
          </q-form>
          <br>
          <div>
            <q-btn label="Gérer les fichiers" color="warning" @click="resourcesList = true" />
            <q-dialog v-model="resourcesList">
              <Resources />
            </q-dialog>
          </div>
          <br>
          <div class="loader" style="z-index: 11000;" v-if="loading">
            <q-spinner-gears size="50px" color="black" />
            <br>
            <div v-if="uploading" class="fixed-layout">
              <q-linear-progress :value="progress" color="blue" :indeterminate="!progress" />
              <div>Téléchargement en cours : {{ progress }} %</div>
            </div>
          </div>
        </div>

        <!-- Colonne du milieu : Prévisualisation intégrée (en petit) -->
        <div class="column">
          <h4><q-icon name="preview" /> Prévisualiser la galerie</h4>
          <div class="preview-wrapper">
            <!-- Composant dynamique affiché à l'échelle (ici 50% par exemple) -->
            <component 
              :is="selectedGalleryComponent" 
              :key="previewKey"
              :exhibitId="exhibitId"
              :homePageProps="false"
            />
          </div>
        </div>

        <!-- Colonne de droite : Sélection des fichiers et choix de galerie -->
        <div class="column">
          <br>
          <div>
            <h4><q-icon name="note_add" /> Sélectionner les fichiers à associés à la galerie</h4>
            <FileSelect
              label="Fichiers"
              :options="options"
              option-label="title"
              outlined
              v-model="filesSelected"
              dense
              multiple
            />
            <br>
            <q-btn label="Enregistrer" color="secondary" @click="saveFile" />
          </div>
          <div>
            <h4><q-icon name="gps_fixed" /> Choisir une galerie</h4>
            <q-select
              v-model="selectedTemplate"
              :options="templates"
              option-label="name"
              label="Galeries"
              @update:model-value="refreshPreview"
            />
            <br>
            <q-btn label="Enregistrer" color="secondary" @click="changeTemplate" />
          </div>
          <div>
            <ResourcesBis ref="resourcesBis" :exhibit-id="exhibitId" @indicesSaved="updatePreview" :key="resourcesBisKey" />
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
import { urlExposition } from '@/utils/urlExposition';
  import { ref, onMounted, computed,} from 'vue';
  import Header from '../components/Header.vue';
  import ResourcesBis from '../components/ResourcesBis.vue';
  import Resources from '../components/Resources.vue';
  import FileSelect from '../components/FileSelect.vue';
  import axios from 'axios';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';

  // Importez vos composants de galerie (exposition)
  import Template_1 from './templates/template_1.vue'
  import Template_2 from './templates/template_2.vue'
  import Template_3 from './templates/template_3.vue'
  import Template_4 from './templates/template_4.vue'
  import Template_5 from './templates/template_5.vue'
  import Template_6 from './templates/template_6.vue'
  import Template_7 from './templates/template_7.vue'
  import Template_8 from './templates/template_8.vue'
  import Template_9 from './templates/template_9.vue'
  import Template_10 from './templates/template_10.vue'
  import Template_11 from './templates/template_11.vue'
  import Template_12 from './templates/template_12.vue'
  import Template_13 from './templates/template_13.vue'
  import Template_14 from './templates/template_14.vue'
  import Template_15 from './templates/template_15.vue'
  import Template_16 from './templates/template_16.vue'
  import Template_17 from './templates/template_17.vue'
  import Template_18 from './templates/template_18.vue'
  import Template_19 from './templates/template_19.vue'
  import Template_20 from './templates/template_20.vue'
  import Template_21 from './templates/template_21.vue'
  import Template_22 from './templates/template_22.vue'
  import Template_23 from './templates/template_23.vue'
  import Template_24 from './templates/template_24.vue'
  import Template_25 from './templates/template_25.vue'

  export default {
    name: 'TemplateManagement', 
    components: {
      Header,
      ResourcesBis,
      Resources,
      FileSelect,
    },
    setup() {
      const router = useRouter();
      const store = useStore();

      // Déclarations
      const templates = ref([]);
      const loading = ref(false);
      const fileInput = ref();
      const fileName = ref();
      const description = ref();
      const title = ref();
      const source = ref('');
      const source_url = ref('');
      const success = ref(false);
      const saveError = ref(false);
      const options = ref([]);
      const exhibitId = computed(() => store.state.exhibitId);
      const selectedTemplate = ref();
      const hasTemplate = ref(false);
      const resourcesList = ref(false);
      const exhibitName = computed(() => store.state.exhibitName);
      const uploading = ref(false);
      const progress = ref(0);
      const resourcesBis = ref(null);
      const dialogOpen = ref(false);
      const filesSelected = ref([]);
      const resourcesBisKey = ref(0);
      const previewKey = ref(0);
      const inputKey = ref(Date.now());
      const templateComponents = {
        template_1: Template_1,
        template_2: Template_2,
        template_3: Template_3,
        template_4: Template_4,
        template_5: Template_5,
        template_6: Template_6,
        template_7: Template_7,
        template_8: Template_8,
        template_9: Template_9,
        template_10: Template_10,
        template_11: Template_11,
        template_12: Template_12,
        template_13: Template_13,
        template_14: Template_14,
        template_15: Template_15,
        template_16: Template_16,
        template_17: Template_17,
        template_18: Template_18,
        template_19: Template_19,
        template_20: Template_20,
        template_21: Template_21,
        template_22: Template_22,
        template_23: Template_23,
        template_24: Template_24,
        template_25: Template_25,
      };

      const getTemplateName = (template) => {
        if (!template) return null;
        if (typeof template === 'string') return template;
        return template.name || null;
      };

      const getTemplateObject = (template) => {
        if (!template) return null;
        if (typeof template === 'object') return template;
        return templates.value.find((item) => item.name === template || item.id === template) || null;
      };

      // Propriété calculée pour déterminer quel composant de galerie afficher
      const selectedGalleryComponent = computed(() => {
        return templateComponents[getTemplateName(selectedTemplate.value)] || Template_1;
      });

      // On reçoit l'événement d'indices sauvegardés afin de mettre à jour la prévisualisation
      const refreshPreview = () => {
        previewKey.value++;
      };

      const updatePreview = async () => {
        await fecthGaleryFiles();
        refreshPreview();
      };

      // Démarrage : chargement des données
      const start = async () => {
        await getTemplates();
        await getCurrentTemplate();
        await getResources();
        await fecthGaleryFiles();
        // Ici, aucune redirection n'est faite : le composant dynamique est affiché dans la zone de prévisualisation
      };

      // Récupération des templates
      const getTemplates = async () => {
        try {
          const url = `${process.env.VUE_APP_BASEURL}/templates`;
          const response = await axios.get(url);
          templates.value = response.data.filter((element) => element.name !== 'template_6');
        } catch (error) {
          console.log(error);
        }
      };

      // Récupération du template courant (s'il existe)
      const getCurrentTemplate = async () => {
        try {
          const url = `${process.env.VUE_APP_BASEURL}/template/${exhibitId.value}`;
          const response = await axios.get(url);
          if (response.data.length > 0 && response.data[0].name !== 'template_6') {
            hasTemplate.value = true;
            selectedTemplate.value = response.data[0];
          }
        } catch (error) {
          console.log(error);
        }
      };

      const getResources = async () => {
        try {
          const url = `${process.env.VUE_APP_BASEURL}/resources`;
          const body = { exhibitId: store.state.exhibitId };
          const response = await axios.post(url, body);
          options.value = response.data;
        } catch (error) {
          console.log(error);
        }
      };

      const importImage = async () => {
        try {
          loading.value = true;
          uploading.value = true;
          progress.value = 0;
          const formData = new FormData();
          formData.append('file', fileInput.value);
          formData.append('name', fileName.value);
          formData.append('description', description.value);
          formData.append('title', title.value);
          formData.append('exhibitId', store.state.exhibitId);
          formData.append('index', store.state.resourcesCount);
          const url = `${process.env.VUE_APP_BASEURL}/file`;

          const response = await axios.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                progress.value = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              }
            },
          });
          if (response.status === 200) {
            loading.value = false;
            uploading.value = false;
            success.value = true;
            setTimeout(async () => {
              success.value = false;
              resourcesBisKey.value++;
              await getResources();
              await fecthGaleryFiles();
            }, 1500);
          }
        } catch (err) {
          console.log(err);
          saveError.value = true;
          uploading.value = false;
          setTimeout(() => {
            saveError.value = false;
          }, 1500);
        }
      };

      const openNewTab = () => {
        window.open(store.getters.exhibitUrl, '_blank');
      };

      const copyToClipboard = async () => {
        try {
          await navigator.clipboard.writeText(store.getters.exhibitUrl);
        } catch (err) {
          console.error('Failed to copy URL: ', err);
        }
      };

      // Changement de template
      const changeTemplate = async () => {
        try {
          const template = getTemplateObject(selectedTemplate.value);
          if (!template) return;
          const url = `${process.env.VUE_APP_BASEURL}/template`;
          const templateName = getTemplateName(template);
          const body = {
            exhibitId: store.state.exhibitId,
            templateId: template.id,
          };
          const exhibitUrl = urlExposition(templateName, exhibitId.value);
          store.commit('SET_EXHIBITURL', exhibitUrl);
          await axios.post(url, body);
          refreshPreview();
          success.value = true;
          setTimeout(() => {
            success.value = false;
            // La prévisualisation se met à jour automatiquement via le composant dynamique
          }, 1500);
        } catch (error) {
          console.log(error);
        }
      };

      const exhibitValidation = async () => {
        try {
          await changeTemplate();
          await resourcesBis.value.saveAllIndices();
          setTimeout(() => {
            success.value = true;
          }, 1600);
          setTimeout(() => {
            success.value = false;
          }, 3000);
        } catch (error) {
          console.log(error);
        }
      };

      const navigateToExpo_bu = () => {
        router.push({ path: `/expo/${store.state.exhibitId}` });
      };

      const navigateToCreation = () => {
        router.push({ path: `/creation` });
      };

      const navigateBack = () => {
        router.go(-1);
      };

      const navigateToAddPoint = () => {
        router.push({ path: `/point` });
      };

      const navigateToExhibits = () => {
        router.push('/admin');
      };

      const selectFile = (event) => {
        const MAX_SIZE = 10000000; // 10MB
        const file = event.target.files[0];
        if (file.size > MAX_SIZE) {
          alert('Le fichier est trop grand, le chargement peut être long.');
        }
        fileInput.value = file;
        if (event.target.files.length !== 0) {
          fileName.value = file.name;
          let nameWithoutExtension = fileName.value.replace(/\.[^/.]+$/, '');
          title.value = nameWithoutExtension;
        }
      };

      const saveFile = async () => {
        const resourceIds = filesSelected.value
          .map((file) => file?.resource_id ?? file?.id)
          .filter((resourceId) => resourceId !== undefined && resourceId !== null);
        try {
          await axios.post(`${process.env.VUE_APP_BASEURL}/galleryResources`, {
            exhibitId: exhibitId.value,
            resourceIds: resourceIds,
          });
          console.log('Resources successfully sent to the API');
          await fecthGaleryFiles();
          resourcesBisKey.value++;
          refreshPreview();
          success.value = true;
          setTimeout(() => {
            store.commit('SET_RESOURCESCOUNT', resourceIds.length);
            success.value = false;
          }, 1500);
        } catch (error) {
          console.error('Error sending resources to the API:', error);
          saveError.value = true;
          setTimeout(() => {
            saveError.value = false;
          }, 1500);
        }
      };

      const fecthGaleryFiles = async () => {
        try {
          const response = await axios.get(`${process.env.VUE_APP_BASEURL}/galleryResources/${exhibitId.value}`);
          filesSelected.value = response.data;
        } catch (error) {
          console.log(error);
        }
      };

      onMounted(start);

      return {
        fileInput,
        fileName,
        loading,
        selectedTemplate,
        options,
        title,
        description,
        source,
        source_url,
        success,
        saveError,
        templates,
        resourcesList,
        exhibitName,
        resourcesBisKey,
        previewKey,
        uploading,
        progress,
        resourcesBis,
        dialogOpen,
        filesSelected,
        inputKey,
        importImage,
        getCurrentTemplate,
        changeTemplate,
        openNewTab,
        navigateToCreation,
        navigateToExpo_bu,
        navigateBack,
        navigateToAddPoint,
        selectFile,
        navigateToExhibits,
        exhibitValidation,
        copyToClipboard,
        saveFile,
        updatePreview,
        refreshPreview,
        selectedGalleryComponent,
        store,
        exhibitId,
      };
    },
  };
  </script>

  <style scoped>
  .notifications-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    width: auto;
    min-width: 300px;
    pointer-events: none;
  }

  .banner {
    margin-bottom: 1rem;
    font-size: 1rem;
    text-align: center;
    animation: fadeIn 0.3s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .container {
    display: flex;
    justify-content: space-between;
  }

  .column {
    flex: 1;
    margin: 10px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
  }

  .navButtons {
    display: flex;
    justify-content: space-between;
  }

  .title {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    margin-left: 1%;
  }

  .preview-wrapper {
    width: 100%;
    height: 200px;
    border: 1px solid #ccc;
    border-radius: 10px;
    overflow: auto;
    position: relative;
  }

  .preview-wrapper :deep(> *) {
    transform: scale(0.4);
    transform-origin: top left;
    position: absolute;
    width: 250%;
  }

  .infos {
    font-size: 16px;
    border: 1px solid gray;
    width: 90%;
    margin: auto;
    margin-bottom: 5px;
    border-radius: 5px;
  }
  h4 {
    font-size: 20px;
    font-weight: 600;
}
</style>
